import {ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';
import {AlertController, IonContent, LoadingController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import { NEVER, Observable, of, zip} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';

import {environment} from 'environment';

import { AlertInput } from '@ionic/core';
import { Content } from 'app/content/model/model';
import {UserContent, UserProfile} from 'app/profile/model/model';
import {UserService} from 'app/profile/services/user.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';
import {ContentService} from '../../services/content.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


import { DefaultPage } from 'app/menu/components/default-page/default-page';
import { Answer, Dialog, Question } from 'app/dialogs/model/model';

import { AnswerType, DialogsService } from 'app/dialogs';

@Component({
  selector: 'content-flow-page',
  templateUrl: 'content-flow-page.html',
  styleUrls: ['content-flow-page.scss'],
})
export class ContentFlowPage extends DefaultPage {

  public isLoading: boolean = false;
  public userContent: UserContent;
  public dialog: Dialog;

  public diagramTotal: number;

  public footerInfo = '';
  public devInfo = '';

  public selOffset: number;

  public answers: Array<Answer>;

  public justAnswered = false;

  public canProceed = false;
  public proceedDia: Dialog;

  public markedAnswerCur = -1;
  
  @ViewChild(IonContent, { static: false }) private pageContent: IonContent;

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private contentService: ContentService,
    private userService: UserService,
    private alertCtrl: AlertController,
    private platform: Platform,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public dialogsService: DialogsService,
    public loadingCtrl: LoadingController,
  ) {
    super(navService);
    this.dialog = <Dialog> this.navService.get('dialog');
    this.userContent = <UserContent> this.navService.get('userContent');
  }

  private ionViewWillEnter(): void {
    this.isLoading = true;
    console.log("will Enter");
    this.load(this.dialog, false);
  }
  
  private load(dialog: Dialog, justSentAnswer: boolean): void {
    this.devInfo = '';
    this.justAnswered = false;
    if ( dialog !== undefined ) {
      this.contentService.getContentFlow(dialog.contentInfo.uc_id)
        .pipe(finalize(() => { this.isLoading = false; }))
        .subscribe((userContent) => { 
          this.diagramTotal = userContent.regularLength !== undefined ? userContent.regularLength : userContent.dialogs.length;
          userContent.dialogs.length = dialog.contentInfo.pos;
          // noch prüfen ob davor unbeantwortete Dialoge
          while ( userContent.dialogs.length > 0 && !this.dialogIsAnswered(userContent.dialogs[userContent.dialogs.length-1])) {
            dialog = userContent.dialogs[userContent.dialogs.length-1];
            userContent.dialogs.length = userContent.dialogs.length-1;
          }
          this.userContent = userContent;
          this.answers = dialog.questions.map((question) => {
            return {
              questionId: question._id,
              answer: '',
            };
          });
          this.dialog = dialog;
          setTimeout(() => this.scrollTo("curDialog"), 50);  
        });
    }
    else if ( this.userContent !== undefined ) {
      this.contentService.getContentFlow(this.userContent._id)
        .pipe(finalize(() => { this.isLoading = false; }))
        .subscribe((userContent) => { 
          this.diagramTotal = userContent.regularLength !== undefined ? userContent.regularLength : userContent.dialogs.length;
          if (userContent.state != 9) {
            for(let i = 0; i < userContent.dialogs.length; i++) {
              if ( !this.dialogIsAnswered(userContent.dialogs[i])) {
                if ( this.userService.getDevContentImmediately() ) {
                  const dia = userContent.dialogs[i]
                  userContent.dialogs.length = i;
                  this.userContent = userContent;
                  this.footerInfo = '';
                  this.answers = dia.questions.map((question) => {
                    return {
                      questionId: question._id,
                      answer: '',
                    };
                  });
                  this.dialog = dia;
                  const diffDays = this.userContent.contentFull.items[i].day - (i == 0 ? 0 : this.userContent.contentFull.items[i-1].day);
                  this.devInfo = "Folgender Impuls kommt "+(diffDays == 0 ? " am selben Tag" : (diffDays == 1 ? " 1 Tag später" : diffDays+" Tage später"));
                  return;
                }
                else {
                  // can we offer to proceed
                  const dia = userContent.dialogs[i];
                  // is it a final Refresh-Feedback-Dialog?
                  if (dia.title === undefined || dia.title.de === undefined || dia.title.de.indexOf('Refresh') == -1) {
                    this.proceedDia = dia;
                    this.canProceed = true;
                  }
                }
                userContent.dialogs.length = i;
              }
            }
          }
          this.userContent = userContent;
          this.dialog = undefined;
          let footerText = '';
          if ( justSentAnswer ) {
            if ( userContent.state == 9 ) {
              footerText = "CONTENT.FLOW.DONE";
            }
            else {
              footerText = "CONTENT.FLOW.THANKS";
            }
          }
          else if ( userContent.state == 5 ) {
            footerText = "CONTENT.FLOW.NEXT_INFO";
          }
          this.justAnswered = justSentAnswer;
          if ( footerText != '' ) {
            this.getDateInfo(this.calcNextDialogDays())
              .subscribe((dateInfo) => {
                this.translateService.get(footerText, {date_info: dateInfo})
                  .subscribe((footerInfo) => {
                    this.footerInfo = footerInfo;
                    setTimeout(() => this.scrollTo("footer"));  
                  });  
               });
          }
        });
    }
  }

  private ionViewDidEnter(): void {
    // setTimeout(() => {
    //   this.scrollToSel();
    // });
  }

  public trackDialog(index: number, dia: Dialog) {
    return dia._id;
  }

  public trackQuestion(index: number, question: Question) {
    return question._id;
  }

  public get diagramValue(): number {
    return this.userContent !== undefined 
      && this.userContent.dialogs !== undefined
      && this.userContent.dialogs.length !== undefined ? this.userContent.dialogs.length : undefined;
  }

  public getTranslated(text: Dictionary<string>): string {
    return getTranslation(text, this.translateService);
  }

  private scrollTo(id:string): void {
      setTimeout(() => {
        const selContentEle = document.getElementById(id);
        if (selContentEle == null) { // ios
          setTimeout(() => {
            this.scrollTo(id)
          }, 500);
          return;
        }
        if (this.selOffset != selContentEle.offsetTop) {
          this.selOffset = selContentEle.offsetTop
          this.pageContent.scrollToPoint(0, this.selOffset, 1000);
          setTimeout(() => {
            this.scrollTo(id);
          }, 500);
        }
      });
  }

  private getDateInfo(nDays: Number): Observable<string> {
    let text = '';
    if (nDays == 0) {
      text = 'CONTENT.FLOW.TODAY';
    }
    else if (nDays == 1) {
      text = 'CONTENT.FLOW.TOMORROW';
    }
    else if (nDays == 2) {
      text = 'CONTENT.FLOW.TOMORROW2';
    }
    else {
      text = 'CONTENT.FLOW.N_DAYS';
    }
    return this.translateService.get(text, {nDays: nDays});
  }

  private calcNextDialogDays() {
    return 1;
  }

  public getQuestionTitle(question: Question): string {
    return getTranslation(question.text, this.translateService);
  }

  public answerChanged(questionId: string, value: string): void {
    const changedAnswer: Answer = this.answers.find((answer) => { return answer.questionId === questionId; });
    if (changedAnswer) {
      changedAnswer.answer = value;
    }
  }

  public get isValid(): boolean {
    return this.validateAnswers();
  }

  private validateAnswers(): boolean {
    if (!this.answers) {
      return false;
    }

    for (const answer of this.answers) {
      if (typeof answer.answer === 'undefined' || answer.answer === '') {
        return false;
      }
    }

    return true;
  }

  public scrollToInvalid():void {
    if (!this.answers) {
      return;
    }

    let i = 0;
    for (const answer of this.answers) {
      if (typeof answer.answer === 'undefined' || answer.answer === '') {
        // now scroll nd highlight 
        this.scrollTo('answer-cur-'+i);
        this.markedAnswerCur = i;
        setTimeout(() => { this.markedAnswerCur = -1; }, 2500);
        break;
      }
      i++;
    }

  }

  public getMinLabel(question: Question): string {
    return question.minLabel !== undefined ? getTranslation(question.minLabel, this.translateService) : undefined;
  }

  public getMaxLabel(question: Question): string {
    return question.maxLabel !== undefined ? getTranslation(question.maxLabel, this.translateService) : undefined;
  }

  public onNextClick(): void {
    if (this.validateAnswers()) {
      this.sendAnswers(false);
    }
  }

  private async sendAnswers(asGoal: boolean): Promise<void> {

    const loader: HTMLIonLoadingElement = await this.loadingCtrl.create({});
    loader.present().then(() => {
      this.dialogsService.postDialogAnswers(this.answers.length != 0 ? this.answers : 
        [{ // dialog without questions
            questionId: '',
            answer: 'DIALOG_ACKNOWLEGED',
            dialogId: this.dialog._id,
        }])
        .pipe(
          catchError((error) => {
            loader.dismiss().then(() => this.showErrorAlert());
            return NEVER;
          }),
          catchError((error) => {
            return of(false);
          }),
          finalize(() => {
            loader.dismiss().then(() => {
              if ( asGoal ) {
                this.navService.push('goals/edit', {dialog: this.dialog});
              } else if ( this.dialog.goalId !== undefined ) {
                this.navService.push('goals/feedback', {dialog: this.dialog});
              } else {
                // this.navService.root('dashboard');
                // load next matching Dialog?
                this.dialogsService.getDialogs()
                  .subscribe((dialogs) => { 
                    for(let i = 0; i < dialogs.length; i++) {
                      if ( dialogs[i].contentInfo !== undefined && dialogs[i].contentInfo.uc_id == this.userContent._id ) {
                        this.load(dialogs[i], true);
                        return;  
                      }
                    }
                    // or reload and display next impulse message  
                    this.load(undefined, true);
                  });
              }
            });
          }))
        .subscribe();
    });

  }

  public onCancelClick(): void {
    this.navService.pop();
  }

  public onGoOnClick(): void {
    this.navService.root('dashboard');
  }

  public onProceedClick(): void {
    this.answers = this.proceedDia.questions.map((question) => {
      return {
        questionId: question._id,
        answer: '',
      };
    });
    this.dialog = this.proceedDia;
    this.proceedDia = undefined;
    this.canProceed = false;
    this.footerInfo = '';
    setTimeout(() => this.scrollTo("curDialog"), 50);  
}

  private showErrorAlert(): void {
    zip(
      this.translateService.get('COMMON.ERROR'),
      this.translateService.get('COMMON.OK'),
      this.translateService.get('DIALOGS.COULD_NOT_SEND_ANSWERS'),
    ).subscribe(async(translations) => {
      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        subHeader: translations[0],
        buttons: [translations[1]],
        // tslint:disable-next-line:no-magic-numbers
        message: translations[2],
      });
      alert.present();
    });
  }

  private dialogIsAnswered(dialog: Dialog): boolean {
    if ( dialog.questions === undefined || dialog.questions.length == 0 ) {
      return dialog.doneDate !== undefined;
    }
    if ( dialog.questions[0].response !== undefined ) {
      return true;
    }
    // Erfolg Best. Dialog?
    return dialog.questions.find(question => question.answerType != AnswerType.DownloadCert) === undefined;
  }
 
  public getPdf(): void {
    this.contentService.getPdf(this.userContent._id, this.getTranslated(this.userContent.contentFull.title))
    .then((info) => {
      console.log(info);
    });
  }
}
